import { Popover } from "@mui/material";
import { isValid, parse } from "date-fns";
import EmojiPicker from "emoji-picker-react";
import Mousetrap from "mousetrap";
import { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  CardHeader,
  Grid,
  IconButton,
  Loading,
  MenuItem,
  Paper,
  Select,
  TextField,
  TimePicker,
  Tooltip,
} from "../../../../../components";
import { OrdemServicosStatusPersonalizadosService } from "../../../../../services";
import { responseErros } from "../../../../../utils";
import {
  contextos,
  contextosCobrancaComDias,
  contextosDisparoAutomatico,
  contextosLote,
  contextosSemAnexo,
  getContextoBase,
  getGatilhoCobranca,
  getVariaveisPorContexto,
  statusCobranca,
} from "../../../resources/constantes";
import CelularMensagemMock from "../celular-mock.component";
import { AnexoMensagemLote } from "./anexo-mensagem-lote.component";

const ordemServicosStatusPersonalizadosService =
  new OrdemServicosStatusPersonalizadosService();

export function MensagemPersonalizadaForm({
  id,
  mensagem,
  handleChange,
  handleOpenEmojiPicker,
  handleEmojiSelect,
  handleChangeHorario,
  inserirVariavel,
  emojiAnchorEl,
  inputErros,
  msgLote,
  imageAnexo,
  setImageAnexo,
  listaContextosCadastrados,
  statusSelecionado,
  setStatusSelecionado,
}) {
  const emojiButtonRef = useRef(null);
  const [statusList, setStatusList] = useState([]);
  const [loading, setLoading] = useState(false);

  const atalhosAddLayout = [
    {
      keys: ["ctrl+e", "command+e"],
      action: async (e) => {
        e.preventDefault();
        const emoji = document.getElementById("emojiButton");
        emoji.click();
        return false;
      },
    },
  ];

  atalhosAddLayout.map(({ keys, action }) => Mousetrap.bind(keys, action));

  Mousetrap.stopCallback = function () {
    return false;
  };

  useEffect(() => {
    if (
      (mensagem?.contexto || "").startsWith("ordem-servico") &&
      statusList.length === 0
    ) {
      buscarStatusPersonalizados();
    }
  }, [mensagem?.contexto, statusList.length]);

  useEffect(() => {
    if (mensagem?.contexto === "cobranca-automatizada") {
      handleChangeStatusCobranca(statusCobranca[0].status);
    }
  }, [mensagem?.contexto]);

  const buscarStatusPersonalizados = async function () {
    setLoading(true);
    const result = await ordemServicosStatusPersonalizadosService.getAll();
    if (!result.isAxiosError) {
      const colunasCompletas = [
        { id: null, descricao: "ABERTO", cor: "#4FBB53" },
        ...result.data,
        { id: null, descricao: "FECHADO", cor: "#004780" },
      ];
      const statusListCompleto = colunasCompletas.map((col) => ({
        ...col,
        id: col.id,
        status: col.descricao,
      }));
      setStatusList(statusListCompleto);

      if (mensagem?.contexto && mensagem.contexto !== "ordem-servico") {
        const statusSlug = mensagem.contexto
          .replace("ordem-servico-", "")
          .toLowerCase();
        const statusInicial = statusListCompleto.find(
          (s) => s.status.toLowerCase() === statusSlug,
        );
        if (statusInicial) {
          setStatusSelecionado(statusInicial);
        }
      }
    } else responseErros(result);
    setLoading(false);
  };

  const handleChangeStatus = (event) => {
    const statusEncontrado = statusList.find(
      (status) => status.status == event.target.value,
    );
    setStatusSelecionado(statusEncontrado);

    handleChange({
      target: {
        name: "contexto",
        value: `ordem-servico-${statusEncontrado.status.toLowerCase()}`,
      },
    });
  };

  const baseContexto = getContextoBase(mensagem?.contexto);

  const statusCobrancaSelecionado =
    statusCobranca.find(
      (item) => mensagem?.contexto === `cobranca-automatizada-${item.status}`,
    )?.status || "";

  const cobrancaComDias = contextosCobrancaComDias.includes(mensagem?.contexto);

  const handleChangeStatusCobranca = (status) => {
    handleChange({
      target: {
        name: "contexto",
        value: `cobranca-automatizada-${status}`,
      },
    });
  };

  const handleChangeDiasAntecedencia = (e) => {
    handleChange({
      target: {
        name: "diasAntecedencia",
        value: e.target.value === "" ? null : Number(e.target.value),
      },
    });
  };

  const contextosShow =
    mensagem?.tipo === "LOTE" || msgLote ? contextosLote : contextos;

  const contextosShowFiltrados = contextosShow.filter(
    (contexto) =>
      !listaContextosCadastrados?.includes(contexto.value) ||
      contexto.value === baseContexto,
  );

  const formatHora = (time) => {
    if (!time) return null;
    const formato = time.length === 5 ? "HH:mm" : "HH:mm:ss";
    const parsed = parse(time, formato, new Date());
    return isValid(parsed) ? parsed : null;
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{ px: 2, height: "calc(100% - 7rem) !important" }}
    >
      <Grid item xs={12} md={9}>
        <Paper
          className="d-flex"
          sx={{
            px: 3,
            py: 2,
            height: "100%",
            boxShadow: "0px 0px 56px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Grid item xs={12} md={5}>
            {msgLote || mensagem?.tipo === "LOTE" ? (
              <AnexoMensagemLote
                imageAnexo={imageAnexo}
                setImageAnexo={setImageAnexo}
              />
            ) : (
              <>
                <CardHeader title="configuração" />
                <div className="d-flex flex-column align-items-center">
                  <Select
                    fullWidth
                    name="contexto"
                    value={baseContexto}
                    onChange={handleChange}
                    label="Contexto da Mensagem"
                    disabled={id}
                    sx={{ mt: 1 }}
                    error={inputErros.get("contexto")}
                  >
                    {contextosShowFiltrados.map((status, index) => (
                      <MenuItem key={index} value={status.value}>
                        {status.label}
                      </MenuItem>
                    ))}
                  </Select>

                  {(mensagem?.contexto || "").startsWith("ordem-servico") && (
                    <Select
                      id="status"
                      name="status"
                      label="Status da Ordem de Serviço"
                      variant="outlined"
                      sx={{ mt: 1 }}
                      value={statusSelecionado?.status || ""}
                      onChange={handleChangeStatus}
                      fullWidth
                      disableClearable
                    >
                      {statusList.map((status, index) => (
                        <MenuItem key={index} value={status.status}>
                          <div className="d-flex align-items-center justify-content-between">
                            {status.status}&nbsp;
                            {status?.cor && (
                              <i
                                className="ph-fill ph-circle"
                                style={{ color: `${status.cor}` }}
                              ></i>
                            )}
                          </div>
                        </MenuItem>
                      ))}
                    </Select>
                  )}

                  {baseContexto === "cobranca-automatizada" && (
                    <Box sx={{ width: "100%", mt: 2 }}>
                      <Select
                        id="statusCobranca"
                        name="statusCobranca"
                        label="Status do Contas"
                        variant="outlined"
                        sx={{ mt: 1 }}
                        value={statusCobrancaSelecionado}
                        onChange={(e) =>
                          handleChangeStatusCobranca(e.target.value)
                        }
                        helperText={getGatilhoCobranca(
                          statusCobrancaSelecionado,
                          mensagem?.diasAntecedencia,
                        )}
                        fullWidth
                        disableClearable
                      >
                        {statusCobranca.map((item, index) => (
                          <MenuItem key={index} value={item.status}>
                            {item.descricao}
                          </MenuItem>
                        ))}
                      </Select>
                      {cobrancaComDias && (
                        <TextField
                          id="diasAntecedencia"
                          name="diasAntecedencia"
                          label="Dias"
                          type="number"
                          fullWidth
                          sx={{ mt: 2 }}
                          InputProps={{ inputProps: { min: 1, max: 365 } }}
                          value={mensagem?.diasAntecedencia ?? ""}
                          onChange={handleChangeDiasAntecedencia}
                          error={inputErros.get("diasAntecedencia")}
                          helperText="Em branco usa o padrão"
                        />
                      )}
                    </Box>
                  )}
                </div>
              </>
            )}
            {contextosDisparoAutomatico.includes(baseContexto) && (
              <Box sx={{ width: "100%", mt: 2 }}>
                <CardHeader title="Horário de Envio" />
                <TimePicker
                  id="horaEnvio"
                  name="horaEnvio"
                  label="Horário"
                  format="HH:mm"
                  shrink={true}
                  minTime={formatHora("03:00")}
                  sx={{ mt: 1 }}
                  value={formatHora(mensagem?.horaEnvio)}
                  onChange={(date) => handleChangeHorario("horaEnvio", date)}
                />
              </Box>
            )}
            {baseContexto === "condicional-vencimento" && (
              <Box sx={{ width: "100%", mt: 2 }}>
                <CardHeader title="Antecedência do Aviso" />
                <TextField
                  id="diasAntecedencia"
                  name="diasAntecedencia"
                  label="Dias de antecedência"
                  type="number"
                  fullWidth
                  sx={{ mt: 1 }}
                  InputProps={{ inputProps: { min: 0, max: 365 } }}
                  value={mensagem?.diasAntecedencia ?? 0}
                  onChange={handleChangeDiasAntecedencia}
                  error={inputErros.get("diasAntecedencia")}
                  helperText="0 envia no próprio dia do vencimento"
                />
              </Box>
            )}
            <Box sx={{ width: "100%", mt: 2 }}>
              <CardHeader title="variáveis disponíveis" />
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {getVariaveisPorContexto(
                  baseContexto,
                  statusSelecionado?.status,
                ).map((variavel, index) => (
                  <Button
                    id={`var-${index + 1}`}
                    key={variavel}
                    variant="outlined"
                    size="small"
                    onClick={() => inserirVariavel(variavel)}
                    sx={{
                      borderRadius: "16px",
                      textTransform: "none",
                      fontSize: "0.75rem",
                      padding: "4px 12px",
                      borderColor: "#ddd",
                      color: "#555",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                        borderColor: "#ccc",
                      },
                    }}
                  >
                    {`{${variavel}}`}
                  </Button>
                ))}
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={1} className="d-flex justify-content-center">
            <hr className="vr" />
          </Grid>

          <Grid item xs={12} md={6.5}>
            <CardHeader title="editor de mensagem" />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <TextField
                id="mensagem"
                name="mensagem"
                label="Texto da Mensagem"
                margin="normal"
                fullWidth
                multiline
                rows={8}
                required
                helperText="Use *texto* para negrito e _texto_ para itálico"
                sx={{ flexGrow: 1 }}
                onChange={handleChange}
                value={mensagem?.mensagem}
                error={inputErros.get("mensagem")}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", mx: 1 }}>
                <Tooltip title="CTRL + E" arrow placement="top">
                  <IconButton
                    id="emojiButton"
                    ref={emojiButtonRef}
                    onClick={handleOpenEmojiPicker}
                    aria-label="adicionar emoji"
                    size="small"
                  >
                    <i
                      className="ph-bold ph-smiley"
                      style={{ fontSize: "20px" }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            <Popover
              open={Boolean(emojiAnchorEl)}
              anchorEl={emojiAnchorEl}
              onClose={() => handleOpenEmojiPicker(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <EmojiPicker
                onEmojiClick={handleEmojiSelect}
                width={300}
                height={350}
                previewConfig={{ showPreview: false }}
                skinTonesDisabled
                searchDisabled
              />
            </Popover>
            {!msgLote &&
              mensagem?.tipo !== "LOTE" &&
              !contextosSemAnexo.includes(baseContexto) && (
                <AnexoMensagemLote
                  imageAnexo={imageAnexo}
                  setImageAnexo={setImageAnexo}
                />
              )}
          </Grid>
        </Paper>
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        className="d-flex justify-content-center align-items-center"
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CelularMensagemMock
            mensagem={mensagem?.mensagem}
            contexto={baseContexto}
            imageAnexo={imageAnexo}
          />
        </Box>
      </Grid>
      <Loading loading={loading} />
    </Grid>
  );
}
